import { createFileRoute } from '@tanstack/react-router';
import { TenantListPage } from '@/pages/admin/tenants/TenantListPage';

export const Route = createFileRoute('/admin/tenants/')({
  component: TenantListPage
});
